import { createTheme } from '@mui/material'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true // removes the `xs` breakpoint
    sm: true
    md: true
    ml: true
    lg: true
    xl: true
  }
}

const switchBackground = '#3f51b5'
const switchThumb = '#384fa1'

export default createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      ml: 1020,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '14px',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '& .MuiSwitch-track': {
            borderRadius: 22 / 2,
            '&:before, &:after': {
              content: '""',
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              width: 16,
              height: 16,
              marginLeft: 2,
            },
          },
          '&.Mui-checked': {
            color: switchThumb,
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: switchBackground,
            opacity: 0.5,
          },
          '&.Mui-checked + .MuiSwitch-thumb': {
            color: switchThumb,
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: 2,
          },
        },
      },
    },
  },
})
